import React from "react";
import * as Styled from "./styled";
import { useDispatch, useSelector } from "react-redux";
import { setPlotMetadata } from "../../../../../../reducers/hub";

import back from "./assets/ic_back.svg";

function Summary(props) {
  const dispatch = useDispatch();
  const geo = useSelector((state) => state.hub.selected?.geo);

  const walletAddress = useSelector((state) => state.wallet.account.address);
  const landId = useSelector((state) => state.hub.selected?.id);

  const onClick = () => {
    const metadata = {
      description: props.data.description ?? "",
      id: landId,
      name: props.data.name,
      ownerAccountAddress: walletAddress,
      ownerName: props.data.owner,
    };

    dispatch(setPlotMetadata(metadata));
    props.onClose();
  };

  return (
    <>
      <Styled.TitleContainer>
        <Styled.Back src={back} onClick={() => props.onBack(props.data)} />
        <Styled.Title>Land Summary</Styled.Title>
      </Styled.TitleContainer>

      <Styled.Info caption="Land name">{props.data.name}</Styled.Info>
      <Styled.Info caption="Owner">{props.data.owner}</Styled.Info>
      {geo && <Styled.Info caption="Address">{geo.name}</Styled.Info>}
      {geo && (
        <Styled.Info caption="Coordinate">
          {geo.coordinates[0]}, {geo.coordinates[1]}
        </Styled.Info>
      )}

      {props.data.description && <Styled.Info caption="Description">{props.data.description}</Styled.Info>}

      <Styled.CompleteButton onClick={() => onClick()}>Complete</Styled.CompleteButton>
    </>
  );
}

export default Summary;
